import { render, staticRenderFns } from "./PdfLayer.vue?vue&type=template&id=6b227414&scoped=true"
import script from "./PdfLayer.vue?vue&type=script&lang=js"
export * from "./PdfLayer.vue?vue&type=script&lang=js"
import style0 from "./PdfLayer.vue?vue&type=style&index=0&id=6b227414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b227414",
  null
  
)

export default component.exports